import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from 'ng2-translate/ng2-translate';
import { LoginService } from './shared/login.service';
import { UserService } from './shared/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.scss'
  ]
})

export class AppComponent {
  loggedIn: boolean = false;
  user: any = null
  constructor(
    private router: Router,
    private loginService: LoginService,
    private userService: UserService,
    private _translate: TranslateService
  ){
    this.loginService.event.subscribe(logged => {
      this.loggedIn = logged;
    });

    this.user = JSON.parse(this.userService.getUser());
    if(this.user == null || this.user == undefined){
      this.loggedIn = false;
    }else{
      this.loggedIn = true;
    }

    const locale = 'ptBR';//document['locale'] as string;

    console.log(locale);

    this._translate.setDefaultLang(locale);
    this._translate.use(locale);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts